import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import List from "../../components/editableGrid/list/list";
import { columnConfig } from './columnConfig';
import t from '../../localization/en/translation.json';
import {  refresh } from "../../theme/icons";
import { MoreMenuOption } from '../../components/moreMenu/moreMenuOptions';
import MoreMenu from '../../components/moreMenu/moreMenu';
import { getAdminClientSizesRequest, updateAdminClientSizesRequest } from '../../store/actions/admin-general-actions';
import { updatefilterState } from '../../store/actions/list-actions';
import { lookupModel } from '../../containers/createProject/lookupModel';
import { getAdminConsoleAccess } from '../../utils/helper-utility';
import { IClientSizes } from '../../models/IAdminClientSizes';
import { ACTION_NAME, DEFAULT_SORT, ROW_MIN_HEIGHT } from "./adminClientSizesConstants";
import AdminClientSizesModal from '../../components/adminClientSizesModal/adminClientSizesModal';
import { IAccessRight } from '../../models/user';
import { ISSPPlatformRole } from '../../models/IRoles';
import { IPagination, getDefaultPaginationModel, getPaginationModel } from '../../models/IPagination';
import './adminClientSizes.scss';

type IProps = RouteComponentProps<any> & {
  accessRight: IAccessRight;
  sspRoles: ISSPPlatformRole[];
  adminClientSizes: lookupModel[];
  getAdminClientSizesRequest: Function;
  updatefilterState: Function;
  paginationDetails: IPagination;
  updateAdminClientSizesRequest: Function;
  isClientSizeUpdated: boolean;
}

interface IState {
  paginationPayload: IPagination;
  isClientSizeModalOpen: boolean;
  selectedClientSize: IClientSizes | null;
  description: string
}

class AdminClientSizes extends Component<IProps, IState> {
  gridApi;
  state = {
    paginationPayload: getPaginationModel({
      ...getDefaultPaginationModel(),
      sortDirection: DEFAULT_SORT.sort,
      sortColumn: DEFAULT_SORT.colId,
      totalRecords: 0,
      filters: []
    }),
    isClientSizeModalOpen: false,
    selectedClientSize: null,
    description: ""
  }

  componentDidMount() {
    this.getAdminClientSizes();
    this.updateFilterState();
  }

  componentDidUpdate(prevProps, prevState) {
    const { paginationPayload } = this.state;
    const { isClientSizeUpdated } = this.props;

    if (prevState.paginationPayload !== paginationPayload) {
      this.getAdminClientSizes();
      this.updateFilterState();
    }

    if(prevProps.isClientSizeUpdated !== isClientSizeUpdated && isClientSizeUpdated) {
      this.getAdminClientSizes();
    }
  }

  getAdminConsoleAccess = () => {
    const { accessRight, sspRoles } = this.props;
    const portalRole = (accessRight?.portalRoles && accessRight.portalRoles.length > 0 && accessRight.portalRoles[0]) || '';
    return getAdminConsoleAccess(portalRole, sspRoles);
  }

  getAdminClientSizes = () => {
    const { paginationPayload } = this.state;

    this.props.getAdminClientSizesRequest(paginationPayload);
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  handlePageNumberChange = (pageNumber) => {
    this.handlePagination({ pageNumber });
  }

  handlePageSizeChange = (pageSize) => {
    this.handlePagination({ pageSize, pageNumber: 1 });
  }

  handleSorting = (sortColumn = DEFAULT_SORT.colId, sortDirection = DEFAULT_SORT.sort) => {
    const { paginationPayload } = this.state;

    if (paginationPayload.sortColumn === sortColumn &&
      paginationPayload.sortDirection === sortDirection) {
      return;
    }

    const updatedPaginationPayload = { ...paginationPayload, sortColumn, sortDirection }
    this.setState({ paginationPayload: updatedPaginationPayload })
  }

  handleFilterChange = (filters, sortColumn = DEFAULT_SORT.colId, sortDirection = DEFAULT_SORT.sort) => {
    const { paginationPayload } = this.state;
    const updatedPayload = { ...paginationPayload, filters, sortColumn, sortDirection, pageNumber: 1 };

    this.setState({ paginationPayload: updatedPayload })
  }

  updateFilterState = () => {
    const { filters = [], sortDirection, sortColumn } = this.state.paginationPayload;
    const isDefaultSort = sortDirection === DEFAULT_SORT.sort && sortColumn === DEFAULT_SORT.colId;
    const isClearAllDisabled = isDefaultSort && !filters.length

    this.props.updatefilterState({ filters, sortDirection, sortColumn, isClearAllDisabled })
  }

  handlePagination = (paginationParams) => {
    const { paginationPayload } = this.state;
    const updatedPaginationPayload = { ...paginationPayload, ...paginationParams };

    this.setState({ paginationPayload: updatedPaginationPayload, })
  }

  handleMoreMenuOptionClick = (actionName: string) => {
   if (actionName === ACTION_NAME.UPDATE) {
      const rows = this.gridApi.getSelectedRows();
      this.setState({ selectedClientSize: rows[0], description: rows[0].description || "", isClientSizeModalOpen: true });
    }
  }

  renderMoreMenu = () => {
    const options: MoreMenuOption[] = [
      { id: "123", title: t.update, icon: refresh, actionName: ACTION_NAME.UPDATE },
    ]

    return (
      <MoreMenu
        controlId="more-menu-apps"
        optionClickFn={this.handleMoreMenuOptionClick}
        options={options}
        vertical
        leftPlacement
      />
    )
  }

  renderDescriptionRows = ({ value }) => (<span>{value}</span>)

  handleUpdateClientSizes = (payload) => {
    const { updateAdminClientSizesRequest } = this.props;

    this.setState({ isClientSizeModalOpen: false });
    updateAdminClientSizesRequest([payload])
  }

  handleUpdateDescription = (description) => this.setState({ description })

  render() {
    const { adminClientSizes, paginationDetails  } = this.props;
    const { paginationPayload, isClientSizeModalOpen, selectedClientSize, description } = this.state;
    const { portalAdminConsole } = this.getAdminConsoleAccess();
    const filteredColumns = portalAdminConsole ? columnConfig.filter(item => item.field !== "iconButton") : columnConfig;

    if (paginationDetails) {
      paginationPayload.totalRecords = paginationDetails.totalRecords;
      paginationPayload.totalRecordsWithoutFilter = paginationDetails.totalRecords || paginationPayload.totalRecordsWithoutFilter;
    }

    return (
      <div className={`admin-client-sizes ${portalAdminConsole ? "read-only" : ""}`}>
          <div className={`client-size-table`}>
            <List
              columnConfig={filteredColumns}
              defaultColDef={defaultColDef} 
              firstColumnBorderRight={true}
              rowData={adminClientSizes}
              paginate={true}
              frameworkComponents={{
                moreMenuCellRenderer: this.renderMoreMenu,
                clientSizeDescriptionCellRender: this.renderDescriptionRows
              }}
              onGridReady={this.onGridReady}
              onSortChanged={this.handleSorting}
              currentPage={paginationPayload.pageNumber}
              pagination={paginationPayload}
              setItemsPerPage={this.handlePageSizeChange}
              onPageChange={this.handlePageNumberChange}
              onFilterChange={this.handleFilterChange}
              defaultSort={[DEFAULT_SORT]}
              getRowHeight={() => ROW_MIN_HEIGHT}
            />

          </div>

        <AdminClientSizesModal
          isOpen={isClientSizeModalOpen}
          onClose={() => this.setState({ isClientSizeModalOpen: false })}
          onConfirm={this.handleUpdateClientSizes}
          selectedClientSize={selectedClientSize}
          onUpdateDescription={this.handleUpdateDescription}
          description={description}
        />
        </div>
    );
  }
}

const defaultColDef = {
  resizable: false,
  // Add other default properties that you want to apply to all columns
};
const mapStateToProps = ({ adminGeneralReducer, meta, meReducer }) => {
  return {
    adminClientSizes: adminGeneralReducer.adminClientSizes,
    paginationDetails: adminGeneralReducer.paginationDetails,
    isClientSizeUpdated: adminGeneralReducer.isClientSizeUpdated,
    accessRight: meReducer.accessRight,
    sspRoles: meta.userRoles
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAdminClientSizesRequest: payload => { dispatch(getAdminClientSizesRequest(payload)) },
    updatefilterState: payload => {dispatch(updatefilterState(payload))},
    updateAdminClientSizesRequest: payload => {dispatch(updateAdminClientSizesRequest(payload))}
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminClientSizes));
